export const initialReportFormValues = {
  faculty: '',
  submitted_by: '',
  submitted_to: '',
  date: '',
  introduction: '',
  training_details: '',
  opening_ceremony: '',
  closing_ceremony: '',
  coordinator_remarks: '',
  // training_evaluation: [{ title: '', image: [], id: -1 }],
  annex: '',
  additional_information:""
};



export interface TrainingReportInterface {

    organization_name: string;
    department: string;
    center: string;
    location: string;
    training_name: string;
    training_code: string;
    batch_name: string;
    start_date: string;
    end_date: string;
    start_training_image_path: string;
    end_training_image_path: string;
    introduction: string;
    training_details: string;
    opening_ceremony: string;
    closing_ceremony: string;
    coordinator_remarks: string;
    annex: string;
    submitted_to: string;
    submitted_by: string;
    report_date: string;
    faculty: FacultyInterface[];
    trainees: TraineeInterface[];
    modules: ModuleInterface[];
    stats: StatsInterface;
    session_feedbacks: SessionFeedbackInterface[];
    module_feedbacks: any[]; // Currently empty
    training_feedback: TrainingFeedbackInterface;
    evaluator_evaluations: EvaluatorEvaluationInterface[];
}

export interface FacultyInterface {
  name: string;
  position: string | null;
  image_path: string | null;
}

export interface TraineeInterface {
  trainee_id: number;
  full_name: string;
  position: string;
  employee_id: string;
  mobile: string;
  email: string;
  gender: string;
  ethnicity: string;
  service_group: string;
  inclusive_group: string | null;
  province: string;
  is_federal: boolean;
  total_days: number;
  present_days: number;
  absent_days: number;
  attendance_percent: number;
  pre_evaluation: EvaluationInterface | null;
  post_evaluation: EvaluationInterface | null;
  key_improvement: number;
}

export interface EvaluationInterface {
  obtained_score: number;
  total_marks: number;
  is_passed: boolean;
  percentage: number;
}

export interface ModuleInterface {
  title: string;
  days: {
    date: string;
    slots: {
      session_name: string;
      topic: string;
      lecturers: string;
    }[];
  }[];
}

export interface StatsInterface {
  service_groups: {
    name: string;
    male: number;
    female: number;
  }[];
  inclusive_groups: any[]; // Currently empty
  provinces: {
    name: string;
    male: number;
    female: number;
  }[];
  ethnicities: {
    name: string;
    male: number;
    female: number;
  }[];
  federal: {
    name: string;
    male: number;
    female: number;
  };
}

export interface SessionFeedbackInterface {
  date: string;
  session_name: string;
  topic: string;
  lecturer_name: string;
  mcq_questions: {
    question: string;
    participant_count: number;
    average_score: number;
  }[];
  text_questions: {
    question: string;
    answers: string[];
  }[];
}

export interface TrainingFeedbackInterface {
  mcq_questions: {
    question: string;
    participant_count: number;
    average_score: number;
  }[];
  text_questions: any[]; // Currently empty
}

export interface EvaluatorEvaluationInterface {
  participant_name: string;
  total_marks: number;
  obtain_marks: number;
  percentage: number;
  division: string;
  rank: number;
}